/**
 * Bandeira do Brasil em SVG (vai no bundle). Emoji de bandeira (🇧🇷) não
 * renderiza no Windows — aparece "BR" ou um quadrado.
 */
export default function BrazilFlag({ width = 18, className = '' }) {
    return (
        <svg width={width} height={(width * 14) / 20} viewBox="0 0 20 14" className={className}
            role="img" aria-hidden="true" focusable="false">
            <rect width="20" height="14" rx="1.5" fill="#009C3B" />
            <polygon points="10,1.6 18.4,7 10,12.4 1.6,7" fill="#FFDF00" />
            <circle cx="10" cy="7" r="3.3" fill="#002776" />
            <path d="M6.9 6.2c2.1-.5 4.4-.2 6.2.9" stroke="#fff" strokeWidth="0.6" fill="none" />
        </svg>
    );
}
